import React, { useState } from 'react';
import { Input } from 'antd';

const { TextArea } = Input;

function InputSaveOnChange ({ record, field, paycodeId, mode, saveValueHandler, 
  component = 'input',
  ...props }) {
  
  const [value, setValue] = useState(record?.[field]);
  const handleSave = (newValue) => {
    if (newValue !== record?.[field]) {
      saveValueHandler?.(newValue, record, field, paycodeId);
    }
  };

  const InputComponent = component === 'textarea' ? TextArea : Input;

  return (
    <>
    {mode === 'edit' ?
      <InputComponent
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onPressEnter={(e) => handleSave(e.target.value)}
      onBlur={() => handleSave(value)}
      { ...props}
    />
      : 
      <>{record?.[field]}</>
    }
    </>
  );
};

export default InputSaveOnChange;